import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "controller-section" }
const _hoisted_2 = { class: "caption bg-light p-2 rounded-pill" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "img-section-name" }

import { nextTick, ref, watch } from "vue";
// Types
import { IPicturesAccomodationExtended } from "@/types/index";

// Props

export default /*@__PURE__*/_defineComponent({
  __name: 'FullScreenOverlayMobile',
  props: {
    allPrestationsImages: {},
    currentIndex: {},
    totalImages: {},
    isFullScreen: { type: Boolean }
  },
  emits: ["toggleFullScreen", "update:currentIndex"],
  setup(__props: any, { emit: __emit }) {

// Vue
const props = __props;

// Emits
const emit = __emit;

// Data
const localCurrentIndex = ref(props.currentIndex);
const localTotalImages = ref(props.totalImages);

// Refs
const carousel = ref<HTMLElement | null>(null);

// Methods
const toggleFullScreen = () => {
  emit("toggleFullScreen");
};

const getImageUrl = (picture: IPicturesAccomodationExtended) => {
  if (!picture) return "";
  return picture.imgXL || picture.imgLarge || picture.img;
};

const updateIndex = () => {
  if (!carousel.value) return;

  const scrollPosition = carousel.value.scrollLeft;
  const itemWidth = carousel.value.scrollWidth / props.allPrestationsImages.length;
  const newIndex = Math.round(scrollPosition / itemWidth);

  if (newIndex !== localCurrentIndex.value) {
    localCurrentIndex.value = newIndex;
    emit("update:currentIndex", newIndex);
  }
};

/**
 * Scrolls the carousel to the specified index.
 * @param {number} index - The index to scroll to.
 */
const handleScroll = (index:number) => {
  if (carousel.value) {
    const itemWidth = carousel.value.scrollWidth / props.allPrestationsImages.length;
    carousel.value.scrollTo({
      left: index * itemWidth,
      behavior: "auto",
    });
  }
}

// Watchers

/**
 * Watch for changes in the `isFullScreen`. 
 * That is needed to scroll the gallery to the correct image based on the index for the first time the scrollable gallery is open in the Overlay for Mobile.
 * `nextTick` is needed to await for all the images to be in the gallery, otherwise we will not have the correct for `carousel.value.scrollWidth`
 */
watch(
  () => props.isFullScreen,
  () => {
    nextTick(() => {
      if (props.isFullScreen) {
        handleScroll(localCurrentIndex.value)
      }
    })
  }
);

/**
 * Watch for changes in the `currentIndex`. 
 * Used to scroll the gallery to the correct image based on the index
 */
watch(
  () => props.currentIndex,
  (newVal) => {
    localCurrentIndex.value = newVal;
    handleScroll(newVal)
  }
);

watch(
  () => props.totalImages,
  (newVal) => {
    localTotalImages.value = newVal;
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "mobile-overlay-content-wrapper",
    onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(localCurrentIndex.value + 1) + "/" + _toDisplayString(localTotalImages.value), 1),
      _createElementVNode("button", {
        onClick: toggleFullScreen,
        class: "close-btn"
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("svg", {
          width: "21",
          height: "21",
          class: "icon"
        }, [
          _createElementVNode("use", { "xlink:href": "#___icon___close-x" })
        ], -1)
      ]))
    ]),
    _createElementVNode("div", {
      class: "imgs-wrapper",
      ref_key: "carousel",
      ref: carousel,
      onScroll: updateIndex
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allPrestationsImages, (image, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${index}-${image.section}`,
          class: "img-container"
        }, [
          _createElementVNode("img", {
            src: getImageUrl(image),
            alt: "Miniature of Accommodation",
            class: "prestation-image rounded"
          }, null, 8, _hoisted_3),
          _createElementVNode("div", _hoisted_4, _toDisplayString(image.section), 1)
        ]))
      }), 128))
    ], 544)
  ]))
}
}

})